// /opt/ptg01-v1/front-extranet/components/PwaRegister.tsx
// Enregistre le service worker au mount root. Silencieux : pas de UI.
// Dev : on évite d'enregistrer pour ne pas perturber Next.js HMR / Turbopack.
'use client';

import { useEffect } from 'react';

export default function PwaRegister() {
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!('serviceWorker' in navigator)) return;
        // Skip en dev pour ne pas interferer avec HMR
        if (process.env.NODE_ENV !== 'production') return;

        navigator.serviceWorker.register('/sw.js').catch(() => { /* noop */ });
    }, []);

    return null;
}
